import { useCallback, createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

export const SiteContext = createContext({ settings: null, refresh: () => {} });

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(async () => {
    const { data } = await api.get("/settings");
    setSettings(data);
    return data;
  }, []);

  useEffect(() => {
    refresh().catch(() => {});
  }, [refresh]);

  useEffect(() => {
    const title = settings?.content?.site_title;
    document.title = title ? `${title} — Fine Art Portfolio` : "ATELIER — Fine Art Portfolio";
  }, [settings]);

  return (
    <SiteContext.Provider value={{ settings, refresh }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
